import './theme/tokens.css'
import './theme/shiki.css'
import 'katex/dist/katex.min.css'
import './theme/print.css'
import './theme/motion.css'

import { mount } from 'svelte'
import { registerSW } from 'virtual:pwa-register'
import App from './App.svelte'

const updateSW = registerSW({
  onNeedRefresh() {
    void updateSW(true)
  },
  onOfflineReady() {},
})

const target = document.getElementById('app')
if (!target) {
  throw new Error('md: missing #app mount target')
}

const app = mount(App, { target })

export default app
